import { API_BASE } from '../config/api';

const handleResponse = async (response, defaultError) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || data.message || defaultError);
  }
  return data;
};

export const fetchManagementSections = async () => {
  const response = await fetch(`${API_BASE}/api/management`);
  return handleResponse(response, 'Failed to load management overview.');
};

export const fetchManagementSectionStatus = async (sectionId) => {
  const response = await fetch(`${API_BASE}/api/management/${sectionId}`);
  return handleResponse(response, 'Failed to load management module status.');
};
